var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBrainElectricitygrey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5603_6257)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.21792 9.35645C4.11335 9.35645 3.21792 10.2519 3.21792 11.3564C3.21792 12.461 4.11335 13.3564 5.21792 13.3564C5.45167 13.3564 5.67606 13.3163 5.88458 13.2426",
    stroke: "#8698A9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.39386 10.4267C2.50078 9.99576 1.88461 9.08164 1.88461 8.02361C1.88461 7.21584 2.24377 6.49195 2.8111 6.00293",
    stroke: "#8698A9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.8316 5.94858C2.65451 5.68384 2.55125 5.36553 2.55125 5.02311C2.55125 4.10264 3.29744 3.35645 4.21792 3.35645C4.59319 3.35645 4.9395 3.48048 5.21808 3.68978",
    stroke: "#8698A9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.3764 3.73333C5.27476 3.51788 5.21794 3.27713 5.21794 3.02311C5.21794 2.10264 5.96413 1.35645 6.8846 1.35645C7.80508 1.35645 8.55127 2.10264 8.55127 3.02311V13.3564",
    stroke: "#8698A9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.8846 13.3564C5.8846 14.0928 6.48156 14.6898 7.21794 14.6898C7.95432 14.6898 8.55127 14.0928 8.55127 13.3564",
    stroke: "#8698A9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.55127 4.69043C8.55127 5.795 9.4467 6.69043 10.5513 6.69043",
    stroke: "#8698A9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2914 6.00293C14.8588 6.49195 15.2179 7.21584 15.2179 8.02361C15.2179 8.49234 15.097 8.93283 14.8846 9.31557",
    stroke: "#8698A9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2709 5.94858C14.448 5.68384 14.5513 5.36553 14.5513 5.02311C14.5513 4.10264 13.8051 3.35645 12.8846 3.35645C12.5093 3.35645 12.163 3.48048 11.8845 3.68978",
    stroke: "#8698A9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.55127 3.02311C8.55127 2.10264 9.29746 1.35645 10.2179 1.35645C11.1384 1.35645 11.8846 2.10264 11.8846 3.02311C11.8846 3.27713 11.8278 3.51788 11.7261 3.73333",
    stroke: "#8698A9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.8846 14.6898C9.14822 14.6898 8.55127 14.0928 8.55127 13.3564",
    stroke: "#8698A9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9957 10.6904L11.8846 12.6904H14.5512L13.4401 14.6904",
    stroke: "#8698A9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5603_6257"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.55127 0.0234375)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrainElectricitygrey);
export default __webpack_public_path__ + "static/media/brain-electricitygrey.398c6475baea89d89a17a683347f69b4.svg";
export { ForwardRef as ReactComponent };